import BN from 'bignumber.js';

export function format(num, decimal = 2): string {
  if (Number.isNaN(num)) {
    return '0';
  }

  // 保留小数位并进行四舍五入
  let price = num.toFixed(decimal);

  // 去掉 ".00" 的部分
  price = price.replace(/\.00$/, '');

  // 去掉 ".x0"（即末尾是零的部分）
  price = price.replace(/\.(\d)0$/, '.$1');

  return price;
}

/**
 * 格式化次数-新版
 * @param {number} num
 * @returns {Object} { num, unit }
 * 只保留中国大陆格式。
 */

export function formatNum(num, lowest = 10000) {
  let currentNumber = Number(num);

  // 如果输入无效，设置为 0
  if (Number.isNaN(currentNumber)) {
    currentNumber = 0;
  }

  const _num = new BN(currentNumber);

  // 大于等于 1 亿
  if (_num.greaterThanOrEqualTo(1e8)) {
    return {
      num: format(_num.div(1e8), 0), // 除以 1 亿
      unit: '亿',
    };
  }

  // 大于等于 'lowest' (默认 1 万)
  if (_num.greaterThanOrEqualTo(lowest)) {
    return {
      num: format(_num.div(lowest), 0), // 除以 1 万
      unit: '万',
    };
  }

  // 小于 1 万，不添加单位
  return {
    num: format(_num),
    unit: '',
  };
}
